// extracted by mini-css-extract-plugin
export default {"badge":"badges_badge__18XNn","dot":"badges_dot__IYAZF","trust":"badges_trust__0+QQB","load":"badges_load__Ew+UC","muted":"badges_muted__FhfYx","alert":"badges_alert__Dssbk"};